function SectionSubText({ children, size, color }) {
    size = size || 'max-w-xl'
    color = color || 'text-black'

    return (
        <div className="mt-6">
            <p className={`text-lg text-center ${color} ${size} mx-auto`}>
                {children}
            </p>
        </div>
    )
}

export default SectionSubText
